import styled, { css } from 'styled-components'
import { border, borderRadius, Color, rem, BaseColor, themeColor, transitions, Typography, buttonReset, spacing } from '~theme'

export const TextualFormElement = styled.input`
  width: 100%;
  flex-grow: 1;
  color: inherit;
  border: none;
  background: transparent;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${themeColor(BaseColor.shade_50)};
    opacity: 1;
  }
`

export const SideButton = styled.button`
  ${buttonReset};
  color: inherit;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: ${rem(4)};
  padding-right: ${rem(4)};
`

const sideElement = css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${themeColor(BaseColor.shade_50)};
  ${transitions(['color'])};
`

export const Prefix = styled.div`
  ${sideElement};
  margin-left: ${rem(4)};

  ${SideButton} {
    margin-left: ${rem(-4)};
  }
`
export const Suffix = styled.div`
  ${sideElement};
  margin-right: ${rem(4)};

  ${SideButton} {
    margin-right: ${rem(-4)};
  }
`

export interface ContainerProps {
  isCode?: boolean
  isError?: boolean
  isDisabled?: boolean
  size: 'large' | 'medium' | 'small'
  variant?: 'default' | 'transparent'
}

export const sizeLarge = css<ContainerProps>`
  height: ${rem(44)};
  padding: 0 ${rem(8)};

  ${TextualFormElement} {
    ${({ isCode }) => (isCode ? Typography.codeSnippetMedium : Typography.labelLarge)};
    ${Typography.textRegular};
    padding: ${rem(12)} ${rem(8)};
  }
`

export const sizeMedium = css<ContainerProps>`
  height: ${rem(40)};
  padding: 0 ${rem(8)};

  ${TextualFormElement} {
    ${({ isCode }) => (isCode ? Typography.codeSnippetMedium : Typography.labelLarge)};
    ${Typography.textRegular};
    padding: ${rem(10)} ${rem(8)};
  }
`

export const sizeSmall = css<ContainerProps>`
  height: ${rem(32)};
  padding: 0 ${rem(4)};

  ${TextualFormElement} {
    ${({ isCode }) => (isCode ? Typography.codeSnippetSmall : Typography.labelMedium)};
    ${Typography.textRegular};
    padding: ${rem(10)} ${rem(8)};
  }
`

export const Container = styled.div<ContainerProps>`
  display: flex;
  padding: 0 ${rem(8)};
  flex-grow: 1;
  border-radius: ${borderRadius};
  border: ${({ variant }) => (variant === 'transparent' ? 'none' : border)};
  ${transitions(['color', 'border-color'])};
  ${({ size }) => {
    if (size === 'large') {
      return sizeLarge
    }
    if (size === 'medium') {
      return sizeMedium
    }

    return sizeSmall
  }};

  color: ${themeColor(BaseColor.shade_90)};
  background: ${({ variant }) => (variant === 'transparent' ? 'transparent' : themeColor(BaseColor.shade_0))};
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
      touch-action: none;
    `}

  &:hover {
    ${Prefix}, ${Suffix} {
      color: ${themeColor(BaseColor.shade_70)};
    }
  }

  &:focus-within {
    border-color: ${themeColor(Color.primary)};
    ${Prefix}, ${Suffix} {
      color: ${themeColor(BaseColor.shade_90)};
    }
  }

  ${props =>
    props.isError &&
    css`
      border-color: ${themeColor(Color.danger)} !important;
    `}
`
